var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[[_vm._m(0)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{},[_vm._v("No charity options currently available")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688650ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/shared/pages/charity-pieta-house/charity-pieta-house.html
// module id = null
// module chunks = 